export enum ActiveBackgroundEnum {
  'DAY'= 0,
  'NIGHT' = 10,
}